var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-radio-group',{staticClass:"mt-0",attrs:{"label":"Leveringsmåte"},on:{"change":_vm.updateDeliveryMethod},model:{value:(_vm.delivery_method),callback:function ($$v) {_vm.delivery_method=$$v},expression:"delivery_method"}},_vm._l((_vm.deliveryMethods),function(deliveryMethod){return _c('v-radio',{key:deliveryMethod.id,attrs:{"label":deliveryMethod.name +
        ' (kr ' +
        parseFloat(deliveryMethod.price) +
        ',-)',"value":deliveryMethod}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }